import {PropsWithChildren} from "react";
import {CreateSubscriptionProvider} from ".";

export function CreateSubscriptionContextWrapper({children}: PropsWithChildren) {
  return <CreateSubscriptionProvider>{children}</CreateSubscriptionProvider>;
}
